import { z } from 'zod';
import { COUPON_TYPES } from '../types/enums.js';
import { dateSchema, moneySchema, optionalMoneySchema, paginationQuerySchema, sortOrderSchema, uuidSchema, } from './common.js';
const couponBaseSchema = z.object({
    code: z
        .string()
        .trim()
        .toUpperCase()
        .min(3, 'Use at least 3 characters')
        .max(50)
        .regex(/^[A-Z0-9_-]+$/, 'Use letters, numbers, hyphens and underscores only'),
    description: z.string().trim().max(500).nullable().optional(),
    type: z.enum(COUPON_TYPES),
    /** Percent for PERCENTAGE, amount for FIXED_AMOUNT, ignored for FREE_SHIPPING. */
    value: moneySchema,
    minSpend: optionalMoneySchema,
    maxDiscount: optionalMoneySchema,
    startsAt: dateSchema.nullable().optional(),
    expiresAt: dateSchema.nullable().optional(),
    usageLimit: z.number().int().min(1).nullable().optional(),
    perCustomerLimit: z.number().int().min(1).nullable().optional(),
    productIds: z.array(uuidSchema).max(200).default([]),
    categoryIds: z.array(uuidSchema).max(50).default([]),
    isActive: z.boolean().default(true),
});
export const createCouponSchema = couponBaseSchema
    .refine((v) => !v.startsAt || !v.expiresAt || v.startsAt < v.expiresAt, {
    message: 'The end date must be after the start date',
    path: ['expiresAt'],
})
    .refine((v) => v.type !== 'PERCENTAGE' || Number(v.value) <= 100, {
    message: 'A percentage discount cannot exceed 100%',
    path: ['value'],
})
    .refine((v) => v.type !== 'PERCENTAGE' || Number(v.value) > 0, {
    message: 'Enter a discount greater than zero',
    path: ['value'],
});
export const updateCouponSchema = couponBaseSchema.partial();
export const couponListQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(200).optional(),
    isActive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((v) => (typeof v === 'string' ? v === 'true' : v))
        .optional(),
    type: z.enum(COUPON_TYPES).optional(),
    sortBy: z.enum(['createdAt', 'code', 'usageCount', 'expiresAt']).default('createdAt'),
    sortOrder: sortOrderSchema,
});
//# sourceMappingURL=coupon.js.map